export function makeDownloadableUrl(
  lines: string[],
  mimeType: "text/csv" | "text/plain" = "text/plain",
): string {
  const blob = new Blob(
    lines.map((line) => line + "\r\n"),
    { type: mimeType },
  );

  return window.URL.createObjectURL(blob);
}
